import { useNavigate } from 'react-router-dom';
import { useToast } from '@/shared/hooks/use-toast';
import { useTranslation } from '@/shared/i18n';
import type { PackPreset } from '../types';

export function usePresetNavigation() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { t } = useTranslation('packs');

  const navigateToNewPreset = (packId?: string, packName?: string) => {
    if (!packId) {
      toast({
        title: t('errorAddingPreset'),
        description: t('savePackFirst'),
        variant: 'destructive',
      });
      return;
    }
    navigate('/presets/new', { state: { packId, packName } });
  };

  const navigateToEditPreset = (
    preset: PackPreset | (PackPreset & { id: string }),
    packId?: string,
    packName?: string
  ) => {
    if (!packId || !preset?.id) return;
    navigate(`/presets/${preset.id}`, { state: { packId, packName } });
  };

  return {
    navigateToNewPreset,
    navigateToEditPreset,
  };
};
